// Base class for common fields
export class AdvertisementBase {
    disciplines: string[];
    rodeoEvents: number[];
    schedules: number[];
    rodeos: number[];
    accountsGroups: number[];

    constructor(rodeos?: number[]) {
        this.disciplines = [];
        this.rodeoEvents = [];
        this.schedules = [];
        this.rodeos = rodeos ?? [];
        this.accountsGroups = [];
    }
}

export class TextAdvertisement extends AdvertisementBase {
    personalize: boolean;
    title: string;
    body: string;
    imgUrls: string[];
    females: boolean;
    males: boolean;

    constructor(rodeos?: number[]) {
        super(rodeos);
        this.personalize = true;
        this.title = undefined;
        this.body = undefined;
        this.imgUrls = [];
        this.females = true;
        this.males = true;
    }
}

export class EmailAdvertisement extends AdvertisementBase {
    subject: string;
    from: string; // current user email
    sendTo: string; // recipient email
    ccEmails: string[];
    body: string;

    constructor(rodeos?: number[]) {
        super(rodeos);
        this.subject = undefined;
        this.from = undefined;
        this.sendTo = undefined;
        this.ccEmails = [];
    }
}

export enum NotificationType {
    Email,
    Push,
    Text
}